// Karuzela produktów — Embla Carousel 8.6.0
(function () {
  'use strict';

  if (window.robinPopularProductsEmbla) return;
  window.robinPopularProductsEmbla = true;

  const instances = new Map();

  function initOne(root) {
    if (instances.has(root)) return;
    if (typeof window.EmblaCarousel !== 'function') return;

    const viewport = root.querySelector(
      '.popular-products__swiper'
    );

    const container = root.querySelector(
      '.popular-products__swiper-wrapper'
    );

    if (!viewport || !container || !container.children.length) {
      return;
    }

    // Usunięcie starej instancji, jeżeli istnieje.
    if (viewport.swiper) {
      viewport.swiper.destroy(true, true);
    }

    const slides = Array.from(container.children);

    // Ta karuzela nie jest już obsługiwana przez Swiper.
    viewport.classList.remove('swiper');
    container.classList.remove('swiper-wrapper');

    slides.forEach(slide => {
      slide.classList.remove('swiper-slide');
    });

    root.classList.add('pp-embla');

    const section = root.closest('.shopify-section') || root;

    const prev = root.querySelector(
      '.popular-products__btn--prev'
    );

    const next = root.querySelector(
      '.popular-products__btn--next'
    );

    const pagination = section.querySelector(
      '.popular-products-progressbar .swiper-pagination'
    );

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const embla = window.EmblaCarousel(viewport, {
      container: container,
      slides: slides,
      axis: 'x',
      align: 'start',
      containScroll: 'trimSnaps',
      loop: false,

      // Po puszczeniu wyrównanie do karty.
      dragFree: false,
      skipSnaps: false,
      slidesToScroll: 1,

      duration: 20,
      dragThreshold: 8,

      watchDrag: true,
      watchResize: true,
      watchSlides: true,
      watchFocus: true
    });

    let progressFill = null;

    if (pagination) {
      pagination.classList.add('pp-embla-progress');

      progressFill = document.createElement('span');
      progressFill.className = 'pp-embla-progress__fill';
      progressFill.setAttribute('aria-hidden', 'true');

      pagination.replaceChildren(progressFill);
    }

    function updateButtons() {
      if (prev) {
        prev.disabled = !embla.canScrollPrev();
      }

      if (next) {
        next.disabled = !embla.canScrollNext();
      }
    }

    function updateProgress() {
      if (!progressFill) return;

      const viewportWidth = viewport.clientWidth;
      const contentWidth = container.scrollWidth;

      const visiblePart = contentWidth > 0
        ? Math.min(1, viewportWidth / contentWidth)
        : 1;

      const progress = Math.max(
        0,
        Math.min(1, embla.scrollProgress())
      );

      const filled = visiblePart + progress * (1 - visiblePart);

      progressFill.style.transform = `scaleX(${filled})`;
    }

    function update() {
      updateButtons();
      updateProgress();
    }

    function onPrev(event) {
      event.preventDefault();
      embla.scrollPrev(reducedMotion.matches);
    }

    function onNext(event) {
      event.preventDefault();
      embla.scrollNext(reducedMotion.matches);
    }

    function preventImageDrag(event) {
      if (
        event.target instanceof Element &&
        event.target.closest('img')
      ) {
        event.preventDefault();
      }
    }

    if (prev) {
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Poprzednie produkty');
      prev.addEventListener('click', onPrev);
    }

    if (next) {
      next.type = 'button';
      next.setAttribute('aria-label', 'Następne produkty');
      next.addEventListener('click', onNext);
    }

    viewport.addEventListener('dragstart', preventImageDrag);

    embla.on('select', updateButtons);
    embla.on('scroll', updateProgress);
    embla.on('reInit', update);

    function destroy() {
      if (prev) {
        prev.removeEventListener('click', onPrev);
      }

      if (next) {
        next.removeEventListener('click', onNext);
      }

      viewport.removeEventListener(
        'dragstart',
        preventImageDrag
      );

      embla.destroy();
      instances.delete(root);
    }

    instances.set(root, { destroy });
    update();
  }

  function initAll(scope) {
    if (
      scope.matches &&
      scope.matches('.popular-products-slider')
    ) {
      initOne(scope);
    }

    scope
      .querySelectorAll('.popular-products-slider')
      .forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(document),
      { once: true }
    );
  } else {
    initAll(document);
  }

  window.addEventListener(
    'load',
    () => initAll(document),
    { once: true }
  );

  document.addEventListener(
    'shopify:section:load',
    event => initAll(event.target)
  );

  document.addEventListener(
    'shopify:section:reorder',
    event => initAll(event.target)
  );

  document.addEventListener('shopify:section:unload', event => {
    for (const [root, instance] of instances) {
      if (
        event.target === root ||
        event.target.contains(root)
      ) {
        instance.destroy();
      }
    }
  });
})();